<template>
  <div class="flex flex-col">
    <div class="flex space-x-2">
        <div class="w-1/2">
            <label>
                <span>Startdato<span v-if="inputDateTypeIsNotSupported"> (ÅÅÅÅ-MM-DD)</span></span>
                <input ref="startdato" type="date" pattern="\d{4}-\d{2}-\d{2}" placeholder="ÅÅÅÅ-MM-DD" v-model="tidspunkt.startdato">
            </label>
            <label>
                <span>Starttidspunkt</span>
                <Tidspunkt v-model="tidspunkt.starttidspunkt" />
            </label>
        </div>
        <div class="w-1/2">
            <label>
                <span>Slutdato<span v-if="inputDateTypeIsNotSupported"> (ÅÅÅÅ-MM-DD)</span></span>
                <input ref="slutdato" type="date" pattern="\d{4}-\d{2}-\d{2}" placeholder="ÅÅÅÅ-MM-DD" v-model="tidspunkt.slutdato">
            </label>
            <label>
                <span>Sluttidspunkt</span>
                <Tidspunkt v-model="tidspunkt.sluttidspunkt" />
            </label>
        </div>
      <div
        v-if="num > 1"
        class="w-2/12 flex flex-col justify-center items-center"
      >
        <div class="font-semibold">
          {{ index + 1 }}
        </div>
        <div>
          <button
            @click.prevent="fjern"
            class="bg-red-600 text-red-50 font-semibold rounded-lg px-4 py-1 mt-2"
          >
            Slet
          </button>
        </div>
      </div>
    </div>
    <div>{{ conflict }}</div>
  </div>
</template>

<script>
/* eslint-disable */
import dayjs from "dayjs";
import da from 'dayjs/locale/da'
import Tidspunkt from "./Tidspunkt.vue";
dayjs.locale(da)

export default {
  name: "BookingTidspunkt",
  components: {
    // Datepicker,
    Tidspunkt,
  },
  props: ["tidspunkt", "index", "tegnetAreal", "fastAreal", "num"],
  data() {
    return {
      conflict: "ukendt",
      da: da,
      inputDateTypeIsNotSupported: false
    };
  },
  watch: {
    // whenever question changes, this function will run
    "tidspunkt.startdato": function () {
          this.lookupStatus();
          if (this.tidspunkt.startdato > this.tidspunkt.slutdato) {
              this.tidspunkt.slutdato = this.tidspunkt.startdato;
          }
    },
    "tidspunkt.starttidspunkt": function () {
      this.lookupStatus();
    },
    "tidspunkt.slutdato": function () {
      this.lookupStatus();
    },
    "tidspunkt.sluttidspunkt": function () {
      this.lookupStatus();
    },
    tegnetAreal: function () {
      this.lookupStatus();
    },
    fastAreal: function () {
      this.lookupStatus();
    },
  },
  methods: {
    // datepickerFormat: (date) => dayjs(date).format("DD-MM-YYYY"),
    fjern: function () {
      this.$emit("fjern", this.index);
    },
    formatDate: function (date, hour) {
      console.log(dayjs(date, "YYYY-MM-DD").hour(hour).startOf("hour").format("YYYY-MM-DD HH:mm"))
      return dayjs(date, "YYYY-MM-DD").hour(hour).startOf("hour").format("YYYY-MM-DD HH:mm");
    },
    lookupStatus: function () {
        if (this.fastAreal == null && this.tegnetAreal == null) {
        this.conflict = "";
        return;
      }
      var conflict = {
        ValgtAreal: this.fastAreal ? { id: this.fastAreal } : null,
        TegnetAreal: this.tegnetAreal
          ? { navn: "Tegnet areal", geometri: this.tegnetAreal }
          : null,
        Tidspunkt: {
          starttidspunkt: this.formatDate(
            this.tidspunkt.startdato,
            this.tidspunkt.starttidspunkt
          ),
          sluttidspunkt: this.formatDate(
            this.tidspunkt.slutdato,
            this.tidspunkt.sluttidspunkt
          ),
        },
      };
      fetch(process.env.VUE_APP_API_URL + "/api/ConflictLookup",  {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(conflict)
      })
      .then(raw => raw.json())
      .then(response => this.conflict = response ? "Arealet er muligvis optaget i dette tidsrum" : "")
    },
  },
  mounted() {
    if (this.$refs.startdato.type == "text" && this.$refs.slutdato.type == "text") this.inputDateTypeIsNotSupported = true
    this.lookupStatus();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
input[type="text"], input[type="date"], input[type="time"] {
  @apply block w-full mt-1 font-normal bg-gray-100 border-transparent rounded-lg outline-none focus:ring-2 ring-aak-blue;
}
</style>